import { getLogger } from '../../utils';
import { useMemo } from 'react';
export const useLogger = (options) => {
    const { namespace, orgId } = options;
    return useMemo(() => getLogger({ namespace, orgId }), [namespace, orgId]);
};
